export const USER_TAG = {
  NaturalPerson: 'NaturalPerson',
  LegalPerson: 'LegalPerson',
  Spam: 'Spam',
  Blocked: 'Blocked',
} as const;

export const DEFAULT_TAGS: string[] = [USER_TAG.NaturalPerson, USER_TAG.LegalPerson];

export const CHAT_USER_TAG = {
  [USER_TAG.NaturalPerson]: 'Pessoas físicas',
  [USER_TAG.LegalPerson]: 'Lojistas',
  [USER_TAG.Spam]: 'Spam',
  [USER_TAG.Blocked]: 'Bloqueados',
} as const;
